<template>
  <div class="display-image-wrapper">
    <div class="cover" v-lazy:background="value" />
  </div>
</template>
<script>
export default {
  props: {
    value: [String],
  },
};
</script>
<style lang="less" scoped>
.display-image-wrapper {
  .cover {
    max-width: 100%;
    padding-bottom: 56.25%;
    background-size: cover !important;
    background-position: center !important;
  }
}
</style>
